<!-- 品质检查 -->
<template>
  <div class="client_form workOrderTem">
    <el-row>
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px" class="demo-ruleForm">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.FaultDescription')">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="" name="1">
                <div>{{ errorDes }}</div>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.order_num')" prop="singleNumber">
            <el-input v-model="form.singleNumber" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.whether_unpack')" prop="isUnpack">
            <el-radio-group v-model="form.isUnpack">
              <el-radio :label="true">{{ $t('workOrder.yes') }}</el-radio>
              <el-radio :label="false">{{ $t('workOrder.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.production_date')" prop="production_date">
            <el-date-picker v-model="form.production_date" type="date" :disabled="true" value-format="timestamp" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.ship_date')" prop="ship_date">
            <el-date-picker v-model="form.ship_date" type="date" :disabled="true" value-format="timestamp" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.return_date')" prop="return_date">
            <el-date-picker v-model="form.return_date" type="date" :clearable="false" value-format="timestamp" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.VisualInspection')" prop="exteriorKey">
            <el-select v-model="form.exteriorKey" @change="changeExterior">
              <el-option v-for="item in exteriorOption" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.FunctionalTest')" prop="functionKey">
            <el-select v-model="form.functionKey" multiple @change="changeFuntion">
              <el-option v-for="item in functionOption" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.handler')" prop="name">
            <el-input v-model="form.name" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.processing_time')" prop="handleTime">
            <el-date-picker v-model="form.handleTime" type="datetime" default-time="14:00:00" value-format="timestamp" style="width: 100%;" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.state_flow')" prop="status">
            <el-select v-model="form.status" style="width: 100%;">
              <template v-for="item in statusOptions">
                <el-option :label="$t('workOrder.'+ item.label)" :value="item.value" />
              </template>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('workOrder.remark')" prop="description">
            <el-input v-model="form.description" type="textarea" />
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('sim.uploadFiles')">
            <el-upload class="upload-demo popUpload" action="" :auto-upload="false" :file-list="fileList" :on-change="handleChange" list-type="picture">
              <el-button size="small" type="primary">{{ $t('company.uploadImg') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('workOrder.uploadPicVideo') }}</div>
            </el-upload>
            <div v-if="form.uploadUrl" class="imgBox">
              <el-image v-if="form.fileType=='image'" :src="form.uploadUrl" :alt="$t('company.backgroundImage')" class="img" style="height: 70px" :preview-src-list="[form.uploadUrl]" />
              <i class="el-icon-close" @click="closeImg" />
              <video v-if="form.fileType=='video'" controls="controls" width="200" height="70">
                <source :src="form.uploadUrl" type="video/mp4">
              </video>
            </div>
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item class="btnWarp">
            <el-button type="primary" :disabled="subDisabled" @click="submitForm('ruleForm')">{{ isEdit?$t('workOrder.Revise'): $t('workOrder.save') }}</el-button>
            <el-button @click="clickCancel('quxiao')">{{ $t('workOrder.cancel') }}</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { uploadImg, uploadImgAndCompression } from '@/api/workOrder'
import { isObjectValueEqual } from '@/utils'
export default {
  components: {},
  props: {
    raw: {},
    deviceInfo: {}
  },
  data() {
    return {
      attrArr: ['description', 'exterior', 'exteriorKey', 'fileType', 'function', 'handleTime', 'id', 'isUnpack', 'name', 'production_date', 'return_date', 'ship_date', 'singleNumber', 'status', 'uploadUrl'], // 需要对比的属性
      initObj: {}, // 判断是否有改变项--初始化时的值
      newObj: {}, // 判断是否有改变项--最新的值
      subDisabled: false,
      form: {
        description: '',
        exterior: '',
        functionKey: [],
        function: '',
        handleTime: new Date().getTime(),
        isUnpack: false,
        name: '',
        production_date: '',
        return_date: '',
        ship_date: '',
        singleNumber: '',
        status: 4,
        uploadUrl: null,
        fileType: null
      },

      statusOptions: [
        { label: 'repair_processing', value: 4 },
        { label: 'line_handling', value: 5 }
      ],
      errorDes: '', // 故障描述,
      activeNames: ['1'],
      descriOption: [],
      exteriorOption: [],
      functionOption: [],
      user: [],
      fileList: [],
      uploadUrl: null, // 上传文件的url
      uploadType: null, // 上传文件的类型
      isEdit: false // 修改
    }
  },
  computed: {
    rules() {
      return {
        production_date: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        exteriorKey: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: ['blur', 'change'] }
        ],
        functionKey: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: ['blur', 'change'] }
        ],
        handleTime: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],

        status: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    raw: {
      deep: true,
      handler(obj) {
        this.initForm(obj)
      }
    }
  },
  mounted() {
    // if (this.deviceInfo.chargerProductionDate) {
    //   this.form.production_date = new Date(this.deviceInfo.chargerProductionDate).getTime()
    // }
    this.initForm(this.raw)
  },
  methods: {
    uploadErrorFn(str) { // 上传文件错误处理
      this.$message({
        type: 'error',
        message: str
      })
      this.fileList = this.fileList.length ? [this.fileList[0]] : []
    },
    handleChange(file) { // 上传弹窗
      if (file.raw.type.indexOf('video') == -1 && file.raw.type.indexOf('image') == -1) { // 格式不对，请上传图片！
        this.uploadErrorFn(this.$t('workOrder.formatWrong'))
        return
      } else if (file.size > 20 * 1024 * 1024) { // 图片大小不能超过5M，请重试！
        this.uploadErrorFn(this.$t('workOrder.overSize').replace('5M', '20M'))
        return
      } else if (file.name.length > 100) { // 图片名称长度不能超过100，请重试！
        this.uploadErrorFn(this.$t('workOrder.imgNameLen'))
        return
      }
      file.childDir = 'productProblemTracking'
      var request = uploadImg
      if (file.raw.size > 1024 * 1024 * 5)request = uploadImgAndCompression // 大于5M压缩
      request(file).then(res => {
        if (res.resultCode == 1001) {
          this.fileList = [file]
          this.uploadUrl = this.form.uploadUrl = res.resultModel
          this.uploadType = this.form.fileType = file.raw.type.indexOf('image') > -1 ? 'image' : 'video'
        } else {
          this.$message({
            type: 'error',
            message: this.$t('workOrder.ImgUploadFailed') // 图片上传失败，请重试！
          })
          this.fileList = this.fileList.length ? [this.fileList[0]] : []
        }
      })
    },
    closeImg() {
      this.uploadType = this.form.fileType = this.uploadUrl = this.form.uploadUrl = null
      this.uploadList = []
    },
    initForm(raw) {
      console.log('品质：raw', raw)
      this.isEdit = false
      if (raw.step3) {
        var step = JSON.parse(raw.step3)
        console.log('品质：initForm:step', step)
        this.form = step
        this.isEdit = true
      }
      var device = this.$storage.get('dtuDeviceInfo') || {}
      this.form.production_date = device.chargerProductionDate ? new Date(device.chargerProductionDate).getTime() : ''
      this.form.ship_date = device.orderDate ? new Date(device.orderDate).getTime() : ''
      var configList = this.$storage.get('configList') || []
      this.descriOption = []
      this.functionOption = []
      this.exteriorOption = []
      configList.forEach((v, i) => {
        if (v.key == 'faultDescription') { // 故障描述由客服反馈而来
          var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
          arr.forEach((m, i) => {
            if (raw.step1 && JSON.parse(raw.step1).descriptionKey == i) {
              this.errorDes = i != 3 ? m : JSON.parse(raw.step1).description
            }
          })
        }
        if (v.key == 'appearance') {
          var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
          arr.forEach((m, i) => {
            this.exteriorOption.push({
              value: i,
              text: m
            })
          })
        } else if (v.key == 'function') {
          var arr2 = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
          arr2.forEach((m, i) => {
            this.functionOption.push({
              value: i,
              text: m
            })
          })
        } else if (v.key == 'user') {
          this.user = v.valueList || []
        }
      })
      this.initObj = this.getObjFn(this.form)
      console.log('initForm:this.form', this.form)
    },
    changeExterior() {
      this.form.exterior = ''
      this.exteriorOption.forEach(v => {
        if (this.form.exteriorKey == v.value) this.form.exterior = v.text
      })
    },
    changeFuntion() {
      this.form.function = ''
      this.functionOption.forEach(v => {
        if (this.form.functionKey.indexOf(v.value) > -1) this.form.function += v.text + ' ; '
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.user && this.form.name != this.user[1]) {
          //   this.$message({
          //     type: 'error',
          //     message: this.$t('workOrder.notPermission')// '提交失败，该处理人无权限，请联系部门负责人'
          //   })
          //   return
          // }
          this.subDisabled = true
          setTimeout(() => {
            this.subDisabled = false
          }, 2000)

          const form = {}
          for (const key in this.raw) {
            if (Object.hasOwnProperty.call(this.raw, key)) {
              const element = this.raw[key]
              form[key] = element
            }
          }
          form.status = this.form.status
          form.step3 = JSON.stringify(this.form)
          this.$emit('save', form)
          console.log('提交：this.form', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    clickCancel(val) {
      this.newObj = this.getObjFn(this.form)
      this.$emit('back', this.initObj, this.newObj, val)
    },
    getObjFn(obj) {
      var newObj = {}
      this.attrArr.forEach(v => {
        newObj[v] = obj[v]
      })
      return newObj
    }
  }
}
</script>

<style lang='scss' scoped>
.client_form {
  // width: 500px;
  margin: 20px auto;
}
</style>
